import React from 'react';
import { motion } from 'framer-motion';
export function StatsBar() {
  const stats = [{
    value: '4.8★',
    label: 'Avg Rating'
  }, {
    value: '500+',
    label: '5-Star Reviews'
  }, {
    value: '20+',
    label: 'Years Experience'
  }, {
    value: '30,000+',
    label: 'Carriers Nationwide'
  }];
  return <section className="bg-brand-navy border-b border-white/10" data-id="element-302">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-303">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-0 md:divide-x md:divide-white/10" data-id="element-304">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="flex flex-col items-center justify-center text-center px-4" data-id="element-305">
              <span className="text-3xl md:text-4xl font-black text-brand-red mb-1" data-id="element-306">
                {stat.value}
              </span>
              <span className="text-sm font-semibold text-slate-300 uppercase tracking-wider" data-id="element-307">
                {stat.label}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}